import React, { useEffect, useState } from 'react';
import { Card, CardBody, Form, Button, Col, Row, FormGroup, Label } from 'reactstrap';
import renderField from './RenderField';

const RenderFormNoSteps = ({
    schema = [],
    formData,
    formErrors,
    handleChange,
    handleMultipleFieldsChange,
    handleSubmit,
    validateForm
}) => {

    const wrappedHandleSubmit = (e) => {
        handleSubmit(e);
    };

    const [isFormValid, setIsFormValid] = useState(false); // Track whole form validity

    // For validating the entire form
    useEffect(() => {
        setIsFormValid(validateForm());
    }, [formData, schema]);

    return (
        <div id="basic-form">
            <Card>
                <CardBody>
                    <Form onSubmit={wrappedHandleSubmit}>
                        {schema.map((tab) => (
                            <div key={tab.id}>
                                <h5>{tab.title}</h5>
                                <Row>
                                    {tab.fields.map((field, idx) => (
                                        <Col md={6} sm={12} key={idx}>
                                            <FormGroup className="mb-3">
                                                {renderField(field, handleChange, formData, handleMultipleFieldsChange)}
                                                {formErrors[field.name] && (
                                                    <div className="text-danger">{formErrors[field.name]}</div>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    ))}
                                </Row>
                                <hr />
                            </div>
                        ))}
                        <Button color="primary" type="submit" disabled={!isFormValid}>Submit</Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
};

export default RenderFormNoSteps;
